import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

//import { filter_movie } from "./api"; // Replace with actual API function
import { getGenreList } from "../api/apiSetUp.js";
import { getConfig } from "../api/apiSetUp.js";
import { getTrending } from "../api/apiSetUp.js";
import { extractDetailData } from "./utility.js";

export const getApiUtility = createAsyncThunk("utility/getApiUtility", async () => {
  const langConfig = await getConfig("getConfigLanguage");
  const countryConfig = await getConfig("getConfigCountry");
  const movGenreList = await getGenreList("getMovieGenreList");
  const tvGenreList = await getGenreList("getTVGenreList");
  const rawTrendingMov = await getTrending("Mov");
  const rawTrendingTv = await getTrending("Tv");

  let trendingMov = rawTrendingMov.map(item => extractDetailData("mov", item, langConfig, movGenreList, true));
  let trendingTv = rawTrendingTv.map(item => extractDetailData("tv", item, langConfig, tvGenreList, true));

  return {
    langConfig,
    countryConfig,
    movGenreList,
    tvGenreList,
    trendingMov,
    trendingTv
  };
});

const ApiUtilitySlice = createSlice({
  name: "apiUtility",
  initialState: {
    apiUtility: {},
    loading: true,
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getApiUtility.pending, (state) => {
      state.loading = true;
      state.error = false;
    })
    .addCase(getApiUtility.fulfilled, (state, action) => {
        state.loading = false;
        state.apiUtility = action.payload;
        state.error = false;
    })
    .addCase(getApiUtility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
    });
  },
});

export default ApiUtilitySlice.reducer;